import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUpRight, Menu, X } from "lucide-react";
import { Monogram } from "./Monogram";

const LINKS = [
  { label: "§ 01 РАБОТИ", href: "#raboti" },
  { label: "§ 02 ПАРТНЬОРИ", href: "#partniori" },
  { label: "§ 03 ЦЕНИ", href: "#ceni" },
  { label: "§ ЗАД КАДЪР", href: "#zad-kadar" },
];

export const Header = ({ onRequest }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <header className="fixed inset-x-0 top-0 z-40 border-b border-[#14110D]/10 bg-[#F4F1EA]/80 backdrop-blur-md">
        <div className="mx-auto flex h-16 max-w-[1440px] items-center justify-between px-5 sm:px-8">
          <a href="#nachalo" data-testid="header-logo" className="group flex items-center gap-3">
            <Monogram className="h-8 w-8 transition-transform duration-500 group-hover:rotate-[8deg]" />
            <span className="hidden font-serif text-lg leading-none tracking-tight text-[#14110D] sm:block">
              Alex Cholakov
              <span className="block font-mono text-[9px] uppercase tracking-[0.35em] text-[#524E48]">filmmaker · producer</span>
            </span>
          </a>

          <nav className="hidden items-center gap-1 lg:flex">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-${l.href.slice(1)}`}
                className="rounded-full px-4 py-2 font-mono text-[11px] uppercase tracking-[0.18em] text-[#524E48] transition-colors duration-300 hover:bg-[#14110D] hover:text-[#F4F1EA]"
              >
                {l.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <span className="hidden rounded-full border border-[#14110D]/15 px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.25em] text-[#8C867E] md:block">
              MMXXVI
            </span>
            <a
              data-testid="header-contact-email"
              href="mailto:alex.cholakoff@gmail.com"
              className="hidden items-center gap-2 rounded-full border border-[#14110D]/20 px-4 py-2.5 font-mono text-[11px] uppercase tracking-[0.15em] text-[#14110D] transition-colors duration-300 hover:bg-[#14110D] hover:text-[#F4F1EA] md:flex"
            >
              Контакт
              <span className="normal-case tracking-normal text-[#C8402A]">alex.cholakoff@gmail.com</span>
            </a>
            <button
              data-testid="header-cta-button"
              onClick={onRequest}
              className="group flex items-center gap-2 rounded-full bg-[#C8402A] px-5 py-2.5 font-mono text-[11px] uppercase tracking-[0.18em] text-[#F4F1EA] transition-colors duration-300 hover:bg-[#B0341F]"
            >
              Заяви проект
              <ArrowUpRight className="h-3.5 w-3.5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </button>
            <button
              data-testid="menu-open-button"
              aria-label="Отвори менюто"
              onClick={() => setOpen(true)}
              className="grid h-10 w-10 place-items-center rounded-full border border-[#14110D]/20 text-[#14110D] transition-colors hover:bg-[#14110D] hover:text-[#F4F1EA] lg:hidden"
            >
              <Menu className="h-4 w-4" />
            </button>
          </div>
        </div>
      </header>

      <AnimatePresence>
        {open && (
          <motion.div
            data-testid="mobile-menu"
            className="fixed inset-0 z-50 flex flex-col bg-[#14110D] text-[#F4F1EA]"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.35 }}
          >
            <div className="flex h-16 items-center justify-between px-5">
              <span className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#F4F1EA]/50">Lumen Studio</span>
              <button
                data-testid="menu-close-button"
                aria-label="Затвори менюто"
                onClick={() => setOpen(false)}
                className="grid h-10 w-10 place-items-center rounded-full border border-[#F4F1EA]/25"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
            <nav className="flex flex-1 flex-col justify-center gap-2 px-8">
              {LINKS.map((l, i) => (
                <motion.a
                  key={l.href}
                  href={l.href}
                  data-testid={`mobile-nav-${l.href.slice(1)}`}
                  onClick={() => setOpen(false)}
                  className="font-serif text-4xl text-[#F4F1EA] transition-colors hover:text-[#C8402A] sm:text-5xl"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.08 + i * 0.07, duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
                >
                  {l.label}
                </motion.a>
              ))}
            </nav>
            <div className="px-8 pb-10">
              <a
                data-testid="mobile-contact-email"
                href="mailto:alex.cholakoff@gmail.com"
                className="font-mono text-[11px] uppercase tracking-[0.2em] text-[#F4F1EA]/70"
              >
                Контакт · <span className="normal-case text-[#C8402A]">alex.cholakoff@gmail.com</span>
              </a>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
